<div class="modal-content">
    <div class="modal-header">
        <h4 class="modal-title fw-bold">{{ 'study-editor.genotyping-samples.create-genotyping-samples-modal.title' | translate }}</h4>
        <button type="button" class="btn-close" (click)="cancel()"></button>
    </div>
    <div class="modal-body">
        <div class="row pt-2">
            <div class="col"><span
                    class="fw-bold">{{ 'study-editor.genotyping-samples.create-genotyping-samples-modal.header' | translate | uppercase }}</span>
            </div>
        </div>
        <div class="row pt-3">
            <div class="col-xs-6 col-md-6">
               {{ 'study-editor.genotyping-samples.create-genotyping-samples-modal.choose-variate' | translate }}
            </div>
            <div class="col-xs-6 col-md-6">
                <ng-select [items]="variables" bindLabel="name" [(ngModel)]="variableSelected" [clearable]="false" required>
                </ng-select>
            </div>
        </div>
        <div class="row pt-3">
            <div class="col-xs-6 col-md-6">
               {{ 'study-editor.genotyping-samples.create-genotyping-samples-modal.taken-by' | translate }}
            </div>
            <div class="col-xs-6 col-md-6">
                <ng-select [items]="users" bindLabel="username" [(ngModel)]="selectedUser" [clearable]="false" required>
                </ng-select>
            </div>
        </div>
        <div class="row pt-3">
            <div class="col-xs-6 col-md-6">
                {{ 'study-editor.genotyping-samples.create-genotyping-samples-modal.sampling-date' | translate }}
            </div>
            <div class="col-xs-6 col-md-6">
                <div class="input-group col">
                    <input class="form-control" [placeholder]="'global.date.placeholder' | translate" [(ngModel)]="dateSampling"
                           ngbDatepicker #samplingDate="ngbDatepicker" id="samplingDate" name="samplingDate" required/>
                    <button class="btn btn-outline-secondary calendar" (click)="samplingDate.toggle()" type="button"><i class="fa fa-calendar"></i></button>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button class="btn btn-secondary" (click)="cancel()">{{ 'cancel' | translate }}</button>
        <button class="btn btn-primary" [disabled]="disableSave()" (click)="save()">{{ 'save' | translate }}</button>
    </div>
</div>
